import React from "react";
import { addToQueue } from '~/redux/uservideo/helpers'
import { get } from 'lodash'

class ThankYou extends React.Component {
  constructor(props) {
    super(props)
    this.state = {addedToQueue: false}
  }
  getVal(key){
    return get(this.props.metadataMap, key)
  }

  pastTense(s){
    const str = s.toLowerCase()
    return str === 'rent' ? `${str}ed`: `${str}d`
  }

  handleWatchClick() {
    const id = this.props.plan.videoID || this.props.plan.contentID;
    addToQueue(id, 'VIDEO', (res) => {
      this.setState({addedToQueue: true});
    });
  }

  renderWatchButton() {
    if(this.props.content.gist.contentType === 'EPISODE' || this.props.content.gist.contentType === 'VIDEO'){
      if(this.state.addedToQueue){
        return <a className="overlay-button added-to-watchlist">{this.getVal('puchaseAddedToWatchlist')}</a>
      } else {
        return <a onClick={this.handleWatchClick.bind(this)} className="watch-later-button overlay-button">{this.getVal('puchaseAddToWatchlist')}</a>
      }
    } else {
      return;
    }
  }

  render() {
    const { content } = this.props
    const showButton = content.gist.scheduleStartDate && content.gist.scheduleStartDate - Date.now() > 0

    return(
      this.props.purchaseStatus === 'failed' ? (
        <div className="purchase-thank-you">
          <p className="header">Sorry</p>
          <p className="top">Your purchase was not successful for {content.gist.title}</p>
        </div>
      ):(
        <div className="purchase-thank-you">
          <p className="header">{this.getVal('purchaseThankTitle')}</p>
          <p className="top"> {this.getVal('purchaseThankMessage')} {content.gist.title}</p>
          <p className="bottom"> {this.getVal('purchaseThankEmail')} details has been sent to {this.props.user.email}</p>
          <div className="buttons">
            {!showButton && <div className="watch-now-button site-background-color overlay-button" onClick={()=>this.props.fn()}>{this.getVal('purchaseThankWatchNow')}</div>}
            {this.renderWatchButton()}
          </div>
        </div>
      )
    )
  }
}

export default ThankYou;